import { IconButton, TextField } from "@mui/material";
import { GridColDef, GridRowId } from "@mui/x-data-grid";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
  OnActionQuantidadeChange(
    quantidade: number | null,
    idLinhaGrid: GridRowId,
  ): void;
  onRemoveItem(idLinhaGrid: GridRowId): void; // 👈 NOVA PROP
  jaEstaAssinado?: boolean; // 👈 Para saber se bloqueia o botão
};

export const GenerateEpiMultiColumns = ({
  OnActionQuantidadeChange,
  onRemoveItem,
  jaEstaAssinado = false,
}: Props): GridColDef[] => {
  return [
    {
      field: "nomeEpi", 
      filterable: false,
      headerName: "EPI",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "ca", 
      filterable: false,
      headerName: "CA",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "quantidade", 
      filterable: false,
      width: 120,
      headerName: "Quantidade",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <TextField
              size="small"
              fullWidth
              type="number"
              variant="outlined"
              disabled={jaEstaAssinado} // 👈 Bloqueia edição se já estiver assinado
              value={row.quantidade ?? ""} 
              onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null;
                OnActionQuantidadeChange(valor, id);
              }}
            />
          </div>
        );
      },
    },
    {
      field: "acoes",
      headerName: "",
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const { id } = params; 
        return (
          <div className="w-full h-full flex items-center justify-center gap-0">
            <IconButton
              disabled={jaEstaAssinado}
              onClick={() => onRemoveItem(id)} 
            >
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={20}
                className={jaEstaAssinado ? "text-gray-400" : "text-red-500"}
              />
            </IconButton>
          </div>
        );
      },
    },
  ];
};